import { Accordion } from "react-bootstrap";
import { ICaseDetailsModel, ICaseTaskModel, TaskStatusEnum } from "../../../models/Cases/CaseDetailsModel";
import UserIcon from "../../../images/user-icon.svg";
import CompletedIcon from "../../../images/completed-user-icon.svg";
import TaskTabs from "./TaskTabs";
import { transformUTCDateWithoutTime } from "../../../utils/dateUtil";

interface ITaskItemProps {
  task: ICaseTaskModel;
  toggleCaseTaskModal: () => void;
  selectedTask: ICaseTaskModel | null;
  getCaseTaskByTaskId: (id: string) => void;
  caseDetails: ICaseDetailsModel | null;
  verifyTask: (values: any, init?: boolean) => Promise<void>
}

const TaskItem = (props: ITaskItemProps) => {
  const { 
    task, 
    toggleCaseTaskModal, 
    selectedTask,
    getCaseTaskByTaskId,
    caseDetails,
    verifyTask
  } = props;

  return (
    <Accordion.Item eventKey={task?.taskId} className={task?.status?.toLowerCase()}>
      <Accordion.Header>
        <div className="task-header">
          <div className="task-title">{task?.title || '--'}</div>
          { task?.status !== TaskStatusEnum.COMPLETED ? <div className={`task-status ${task?.status?.toLowerCase()}`}>
            {task?.status?.toLowerCase()?.split(/[-_]/).join(' ') || '--'}
          </div> : <></>}
          <div className="task-assignee">
            <img src={task?.status === TaskStatusEnum.COMPLETED ? CompletedIcon : UserIcon} alt="UserIcon" /> 
            <span className="assignee-text">{task?.taskManager || '--'}</span>
          </div>
          <div className="task-date">
            { 
              task?.status === TaskStatusEnum.COMPLETED ? 
              `Completed: ${task?.updatedDate ? transformUTCDateWithoutTime(task?.updatedDate)  : '--'}` : 
              `Due: ${task?.dueDate ? transformUTCDateWithoutTime(task?.dueDate)  : '--'}`
            }
          </div>
        </div>
      </Accordion.Header>
        <Accordion.Body>
          <TaskTabs 
            task={task} 
            toggleCaseTaskModal={toggleCaseTaskModal}
            selectedTask={selectedTask}
            getCaseTaskByTaskId={getCaseTaskByTaskId}
            caseDetails={caseDetails}
            verifyTask={verifyTask}
          />
        </Accordion.Body>
    </Accordion.Item>
  )
}

export default TaskItem